import { create } from 'zustand';

import { CountryItem } from '@services/types';

type LocationState = {
    location: CountryItem | null;
    setLocation: (location: CountryItem) => void;
};

export const useLocationStore = create<LocationState>((set) => ({
    location: null,
    setLocation: (location) => set({ location }),
}));
